export const SoftHyphen = () => '\u00AD';
